<template>
  <transition name="fade-in">
    <div v-if="visible" class="punch-modal-wrapper">
      <div class="face-recognition-box">
        <div class="close" @click="close" />
        <div class="avatar">
          <div class="circle-wrapper" />
          <transition name="disappear">
            <div v-if="!init" class="media mask">
              <div class="point" />
            </div>
          </transition>
          <div id="container" class="container circle face-recognition-modal">
            <div class="__d"></div>
          </div>
          <img v-show="imageUrl" ref="photo" class="media photo" :src="imageUrl" alt="" />
        </div>
        <status-bar :status="status" :remark="remark" @reset="resetCamera" />
      </div>
    </div>
  </transition>
</template>

<script>
import statusBar from './statusBar';
import { STATUS_MAP } from './constants';
import store from '@/store';
import camera from '@zyf2e/camera';
let timer1 = null;
let timer2 = null;
let callbackTimer = null;
let faceRecognitionTimer = null;
const faceRecognitionCount = 10;

export default {
  name: 'punchModal',
  components: {
    statusBar
  },
  data() {
    return {
      visible: false,
      mediaStreamTrack: null,
      webRtc: null,
      mediaSize: {
        width: 364,
        height: 364
      },
      init: false,
      status: STATUS_MAP.START,
      remark: '',
      success: () => Promise.resolve(),
      successCallback: null,
      imageUrl: '',
      successDelayDuration: 2500
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.initCamera();
        });
      } else {
        camera.stop();
        timer1 && clearTimeout(timer1);
        timer2 && clearTimeout(timer2);
        faceRecognitionTimer && clearTimeout(faceRecognitionTimer);
        this.init = false;
        this.status = STATUS_MAP.START;
        this.imageUrl = '';
        this.remark = '';
        this.webRtc && this.webRtc.stopVideoPreview();
        this.success = () => Promise.resolve();
      }
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
      callbackTimer && clearTimeout(callbackTimer);
    },
    async initCamera() {
      console.log('init');
      const {
        mediaSize: { width, height }
      } = this;
      camera.init({
        container: '.__d'
        // debug: true
      });
      await camera.start();

      this.init = true;
      // setTimeout(() => {
      //   const data = camera.screenshot();
      //   this.imageUrl = data;
      // }, 5000);
      // return;
      // 云信webRtc
      // store.dispatch('webRtc/initWebRtc').then(webRtc => {
      // if (webRtc) {
      timer1 = setTimeout(() => {
        // this.webRtc = webRtc;
        // webRtc.startVideoPreview({ container: '.face-recognition-modal' }).then(_ => {
        this.status = STATUS_MAP.WAIT;

        let recognitionCount = 1;
        const faceRecognition = () => {
          // webRtc.screenshotCanvas().then(screenshot => {
          const screenshot = camera.screenshot();
          if (screenshot !== 'data:,') {
            this.init = true;
            this.success(screenshot.replace(/^data:image\/\w+;base64,/, ''), this).then(isRecognition => {
              if (isRecognition || recognitionCount === faceRecognitionCount) {
                if (isRecognition) {
                  setTimeout(() => {
                    this.visible = false;
                    this.successCallback &&
                      (callbackTimer = setTimeout(() => {
                        this.successCallback();
                      }, 300));
                  }, this.successDelayDuration);
                }

                if (recognitionCount === faceRecognitionCount) {
                  this.status = STATUS_MAP.UNIDENTIFICATION;
                }

                this.imageUrl = screenshot;
                this.$refs.photo.onload = () => {
                  // camera.stop();
                  // webRtc.stopVideoPreview();
                };
              } else {
                faceRecognitionTimer = setTimeout(() => {
                  recognitionCount++;
                  faceRecognition();
                }, 3000);
              }
            });
          } else {
            // setTimeout hack 优先打开摄像头
            setTimeout(() => faceRecognition());
          }
          // });
        };

        faceRecognition();
        // });
      }, 300);
      // }
      // });
    },
    resetCamera() {
      this.init = false;
      this.status = STATUS_MAP.START;
      this.imageUrl = '';
      // const node = document.querySelector('#container div');
      // if (node) {
      //   node.parentNode.removeChild(node);
      // }
      // this.close();
      // this.$nextTick(() => {
      //   this.open();
      // });
      this.initCamera();
    }
  }
};
</script>

<style lang="scss">
.punch-modal-wrapper {
  #__videoCamera {
    border-radius: 50%;
  }
  #__videoCanvas {
    border-radius: 50%;
  }
}
</style>
<style lang="scss" scoped>
.punch-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  /*top: 48px;*/
  /*left: 240px;*/
  z-index: 999;
  width: 100%;
  height: 100%;
  /*width: calc(100vw - 240px);*/
  /*height: calc(100vh - 48px);*/
  background-color: rgba(0, 0, 0, 0.5);

  .face-recognition-box {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 35px 0;
    width: 576px;
    height: 600px;
    transform: translate3d(-50%, -50%, 0);
    background-color: #fff;
    border-radius: 4px;

    .close {
      position: absolute;
      top: 13px;
      right: 13px;
      width: 16px;
      height: 16px;
      background-image: url('~@/assets/img/icon_close.png');
      background-size: 100% 100%;
      background-repeat: no-repeats;
      cursor: pointer;
    }

    .avatar {
      position: relative;
      margin-bottom: 15px;
      width: 426px;
      height: 426px;

      .circle-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        width: 426px;
        height: 426px;
        background-image: url('~@/assets/img/circle-bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        animation: 3s linear infinite rotate;
      }

      .container {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 5;
        width: 364px;
        height: 364px;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }

      .media {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 5;
        width: 364px;
        height: 364px;
        border-radius: 50%;
        transform: translate(-50%, -50%);

        &.camera {
          z-index: 6;
          //transform: translate(-50%, -50%) rotateY(180deg);
        }

        &.photo {
          object-fit: cover;
          z-index: 7;
          //transform: translate(-50%, -50%) rotateY(180deg);
        }

        &.mask {
          position: relative;
          width: 366px;
          height: 366px;
          z-index: 9;
          background-color: #f7f9fa;

          .point {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: #fff;
            animation: 1s linear infinite scale;
          }
        }
      }
    }
  }
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: all 0.3s;

  .face-recognition-box {
    transition: all 0.3s;
  }
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;

  .face-recognition-box {
    transform: translate3d(-50%, -80%, 0);
  }
}

.disappear-leave-active {
  transition: all 1s;
}

.disappear-leave-to {
  opacity: 0;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes scale {
  0% {
    transform: translate(-50%, -50%) scale(0.5);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }
  100% {
    transform: translate(-50%, -50%) scale(0.5);
  }
}
.__d {
  width: 100%;
  height: 100%;
}
</style>
